<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-h-screen">

    <!-- Content -->
    <div class="flex flex-col flex-auto min-h-screen">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>
